import React, {useEffect, useState} from 'react'
import {Box, Flex, useStyleConfig, HStack} from '@chakra-ui/react'
import VerticalLineIcon from '../icons/generic/vertical-line'
import {FormattedMessage} from 'react-intl'
import CustomLink from '../custom-link'
import PropTypes from 'prop-types'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const CorporateBenefitBanner = ({onExit}) => {
    const styles = useStyleConfig('SovraHeader')
    const {locale} = useMultiSite()

    const [landingUrl, setLandingUrl] = useState(`/${locale?.alias}`)

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const path = window.location.pathname + window.location.search
            sessionStorage.setItem('corporateLandingUrl', path)
            setLandingUrl(path)
        }
    }, [])

    return (
        <Flex w="100%" pos="relative" zIndex={1200}>
            <Box {...styles.container} {...styles.containerDesktop} display="flex">
                <HStack {...styles.hstack}>
                    <CustomLink
                        href={landingUrl}
                        asButton={true}
                        variant="inverse-icon-button"
                        {...styles.label}
                    >
                        <FormattedMessage
                            id="corporate_benefit_banner.title"
                            defaultMessage="Discover the Corporate Benefit offer"
                        />
                    </CustomLink>

                    <Flex align="center" justify="center" flex="1">
                        <VerticalLineIcon {...styles.icon} />
                    </Flex>
                    <CustomLink
                        isExternal={false}
                        onClick={async (e) => {
                            e.preventDefault()
                            if (onExit) {
                                await onExit()
                            }
                            window.location.href = `/${locale?.alias}`
                        }}
                        asButton={true}
                        variant="inverse-icon-button"
                        {...styles.label}
                    >
                        <FormattedMessage
                            id="corporate_benefit_banner.exit"
                            defaultMessage="Exit"
                        />
                    </CustomLink>
                </HStack>
            </Box>
        </Flex>
    )
}

CorporateBenefitBanner.propTypes = {
    onExit: PropTypes.func.isRequired,
}

CorporateBenefitBanner.getTemplateName = () => 'corporate-benefit-banner'

export default CorporateBenefitBanner
